export class CappingData {
    public advTracker: string;
    public cid?: string;
    public code: string;
    public featureName?: string;

    public constructor(init?: Partial<CappingData>) {
        Object.assign(this, init);
    }
}
